import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import { StatementSummaryAction, useStatementSummaryProvider } from '../StatementSummary.Hooks';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function StatementSummaryList() {
  const { lang } = getLocales();
  const { listApi, dealerGroupListApi, statementSummaries, pageRouter } = useStatementSummaryProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.statements}
      render={lang.noInfo}
    />
  ) : (
    <table
      className={ThemeTableSimple}
      data-loading={listApi.isExecuting || dealerGroupListApi.isExecuting ? true : undefined}
    >
      <thead>
        <tr>
          <th>{lang.dealerGroup}</th>
          <th>{lang.dealers}</th>
          <th>{lang.invoiceDate}</th>
          <th>{lang.fromDate}</th>
          <th>{lang.toDate}</th>
          <th style={{ justifyContent: 'flex-end' }}>{lang.totalAmount}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={statementSummaries}
          render={({ data: statementSummary }) => (
            <tr key={statementSummary.id}>
              <td>{statementSummary.displayInfo.title}</td>
              <td>{statementSummary.displayInfo.subtitle}</td>
              <td>{statementSummary.displayInfo.info}</td>
              <td>{localizeDate(statementSummary.fromDate, defaultDateTimeFormat)}</td>
              <td>{localizeDate(statementSummary.toDate, defaultDateTimeFormat)}</td>
              <td style={{ alignItems: 'flex-end' }}>
                <b>
                  <FormatValue
                    value={`${(
                      statementSummary.contracts.reduce(
                        (sum, obj) =>
                          sum + (obj.client?.taxExempt ? obj.paymentAmountCAD : obj.paymentAmountWithTaxCAD),
                        0
                      ) || 0
                    ).toFixed(2)}$`}
                  />
                </b>
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: statementSummary.id.toString(),
                      action: StatementSummaryAction.PRINT,
                      router: pageRouter,
                    }}
                    disabled={!permissions.CREATE_STATEMENTSUMMARY}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-print" />}
                    htmlElementProps={{ title: lang.print }}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: statementSummary.id.toString(),
                      action: StatementSummaryAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_STATEMENTSUMMARY}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                  />
                  <Button />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
